var ConferencePageController = /** @class */ (function () {
    /*@ngInject*/
    function ConferencePageController($timeout, utilityService) {
        this.$timeout = $timeout;
        this.utilityService = utilityService;
    }
    ConferencePageController.prototype.$onInit = function () {
        var _this = this;
        this.$stateParams = this.$transition$.params();
        this.isLoaded = false;
        this.candidateId = this.$stateParams.c;
        this.jobId = this.$stateParams.j;
        this.jobMatchId = this.$stateParams.jm;
        this.scheduleId = this.$stateParams.sh;
        this.type = "u";
        // this.type = this.$stateParams.t;
        this.mode = this.$stateParams.mode;
        this.workflowStep = this.$stateParams.ws;
        this.utilityService.toggleHeaderNavDisplay(false);
        this.$timeout(function () {
            _this.isLoaded = true;
        }, 4000);
    };
    return ConferencePageController;
}());
export { ConferencePageController };
ConferencePageController.$inject = ['$timeout', 'utilityService'];
import * as TEMPLATE from 'raw-loader!./conference-page.html';
export var ConferencePageComponent = {
    selector: 'conferencePage',
    component: {
        bindings: { $transition$: '<' },
        template: TEMPLATE.default,
        // templateUrl: 'app/partials/missioncontrol/conference/conference-page.html',
        controller: ConferencePageController
    }
};
//# sourceMappingURL=conference-page.component.js.map